<template>
  <div class="order">
    <div class="inner">
      <ul>
        <li class="item" v-for="item in completedItems" :key="item.name">
          <MenuItem :item="item" :completed="true" />
        </li>
      </ul>

      <div class="order-total">
        Totalt: {{ orderTotal }} kr
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import MenuItem from 'components/order/menu-item';

  export default {
    name: 'OrderBasket',
    components: { MenuItem },

    computed: {
      ...mapState('order', ['completed', 'menu']),
      ...mapGetters('order', ['orderTotal']),

      completedItems () {
        return this.completed.items.map(i => {
          return { i, ...this.itemFor(i.id) };
        });
      }
    },

    methods: {
      itemFor (id) {
        const menuItems = this.menu.map(mi => mi.items).flat(1);
        const item = menuItems.find(i => i.id === id);
        return item ?? { data: { name: 'Borttagen produkt' } };
      }
    }

  };
</script>

<style lang="stylus" scoped>
  @require '~global/typo'
  @require '~global/helpers'

  .order
    @extend .order-box

  h1
    @extend .t-orderHeader

  .menu-item
    margin-bottom: .5rem

  .menu-item:last-of-type
    margin-bottom: 1rem

  .order-total
    text-align: left
    position: relative
    padding-top: 1rem
    margin-top: 1.4rem
    text-transform: uppercase

    &:before
      content: ""
      position: absolute
      top: 0
      left: -1.6rem
      right: -1.6rem
      height: 1px
      background-image: repeating-linear-gradient(to right, black 0 6px, transparent 6px 9px)

  .order .inner
    padding: 2rem 2rem 1rem 2rem
</style>
